"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayClientDetailListSerialiser = exports.GatewayClientDetailListSerialiserClass = void 0;
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var gateway_client_detail_serialiser_1 = require("./../../services/gateway-control/gateway-client-detail-serialiser");
/**
 * Serialiser for {@link GatewayClientDetail}
 */
var GatewayClientDetailListSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayClientDetailListSerialiserClass, _super);
    function GatewayClientDetailListSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayClientDetailList} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayClientDetailList} that was read
     */
    GatewayClientDetailListSerialiserClass.prototype.read = function (bis) {
        return {
            gatewayClientDetails: Codec.readCollection(bis, gateway_client_detail_serialiser_1.GatewayClientDetailSerialiser.read)
        };
    };
    return GatewayClientDetailListSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayClientDetailListSerialiserClass = GatewayClientDetailListSerialiserClass;
/**
 * The {@link GatewayClientDetailListSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.GatewayClientDetailListSerialiser = new GatewayClientDetailListSerialiserClass();
